import { clearSession } from "../../utils/session";

interface AuthState {
    loading: boolean;
    user: any;
    token: string | null;
    error: string | null;
    menus: number[];
    submenus: number[];
    roleid: number | null;
}

const initialState: AuthState = {
    loading: false,
    user: localStorage.getItem("token")
        ? {
            username: localStorage.getItem("username"),
            employeename: localStorage.getItem("employeename"),
            employeeid: localStorage.getItem("employeeid"),
        }
        : null,
    token: localStorage.getItem("token"),
    error: null,
    menus: JSON.parse(localStorage.getItem("menus") || "[]"),
    submenus: JSON.parse(localStorage.getItem("submenus") || "[]"),
    roleid: Number(localStorage.getItem("roleid")) || null,
};

export default function authReducer(
    state = initialState,
    action: any
): AuthState {
    switch (action.type) {
        case "LOGIN_REQUEST":
            return { ...state, loading: true, error: null };

        case "LOGIN_SUCCESS":
            //console.log("REDUCER: LOGIN_SUCCESS received", action.payload);
            return {
                ...state,
                loading: false,
                user: action.payload,
                error: null,
            };
        case "LOGIN_FAILURE":
            return { ...state, loading: false, error: action.payload };

        case "VERIFY_OTP_REQUEST":
            return { ...state, loading: true, error: null };


        case "VERIFY_OTP_SUCCESS": {
            const {
                token, menus, submenus, roleid,
                employeename, employeeid, role, cityid,
            } = action.payload;

            const name = employeename || state.user?.username || "";

            return {
                ...state,
                loading: false,
                user: {
                    username: state.user?.username,
                    employeename: name,
                    employeeid,
                    role,
                    cityid,
                },
                token,
                menus: menus ?? [],
                submenus: submenus ?? [],
                roleid: roleid ?? null,
                error: null,
            };
        }

        case "VERIFY_OTP_FAILURE":
            return { ...state, loading: false, error: action.payload };

        case "LOGOUT_REQUEST":
            return { ...state, loading: true };

        case "LOGOUT_SUCCESS":
        case "LOGOUT_LOCAL":
        case "LOGOUT":
            clearSession();
            return {
                ...state,
                loading: false,
                user: null,
                token: null,
                menus: [],
                submenus: [],
                roleid: null,
                error: null,
            };

        default:
            return state;
    }
}